import React from 'react';
import { connect } from 'react-redux';
import { ErrorBoundary, MetaHeaderTags } from 'mm-ui-components';
import {
    getCanonicalUrl,
    getFacebookAppId,
    getLogoUrl,
    getFacebookPageId, getFavicon, getSiteName,
    getPageDescription, getPageImage, getPageTitle, getTwitterAccount, getAmpURL,
} from '../../store/config/config.selectors';
import { Article } from '../../store/template/template.state.types';
import { AppState } from '../../store/initialStateRegistration';

interface MetaTagsProps {
    articles?: Article[]
}

const mapMetaTagsToProps = (state:AppState, { articles = [] }: MetaTagsProps) => {
  return {
    facebookAppId: getFacebookAppId(state),
    facebookPageId: getFacebookPageId(state),
    description: getPageDescription(state),
    siteName: getSiteName(state),
    canonicalUrl: getCanonicalUrl(state),
    favicon: getFavicon(state),
    title: getPageTitle(state),
    twitterAccount: getTwitterAccount(state),
    pageImage: getPageImage(state),
    articles,
    logoUrl: getLogoUrl(state),
    ampURL: getAmpURL(state),
  };
};

export const MetaTagsConnected = connect(mapMetaTagsToProps)(MetaHeaderTags);
export const MetaTags = ({ articles }:MetaTagsProps) => <ErrorBoundary><MetaTagsConnected articles={articles} /></ErrorBoundary>;
